export default {
  fullBindingTitle1025: 'NFC - 1025 FULL 绑定',
  nddcBindingTitle1025: 'NFC - 1025 NDDC 绑定',
  fullBindingTitle1027: 'NFC - 1027 FULL 绑定',
  nddcBindingTitle1027: 'NFC - 1027 NDDC 绑定',
  bindingTitle: 'RFID - NDDC 绑定',
  unbindByCartonTitle: 'RFID - NDDC 按箱解绑',
  unbindByPieceTitle: 'RFID - NDDC 按件解绑',
  unbindBySoTitle: 'RFID - NDDC 按SO解绑',
  so: 'SO',
  unbindByCartonSuccess: '解绑成功',
  bindByCartonSuccess: '绑定成功',
  notChannel: '请为该手持枪添加渠道权限信息。',
  notRegisterTitle: '扫码枪未注册',
  notRegister: '该扫码枪暂未注册在TraceHub中，请先提供相应的扫码枪编号及Mac地址进行注册。',
  cartonNo: '箱号',
  upc: 'UPC',
  unknownSku: '未知SKU',
  rfidEpc: 'RFID EPC',
  qrCode: 'QR Code',
  salesOrder: '订单号',
  switchToQrCode: '切换 QR Code',
  switchToRfidEpc: '切换 RFID EPC',
  bindResult: '绑定结果',
  rfid: 'RFID',
  qr: 'QR',
  sku: 'SKU',
  skuScanCount: '该产品扫描计数',
  unitScanCount: '该箱扫描计数',
  nextCarton: '下一箱',
  nextEpc: '下一件',
  clear: '清空',
  errorcode_30007: '此箱号已完成绑定。',
  errorcode_30008: '此箱号不存在于波次列表中。',
  errorcode_30009: '此箱号中无此产品。',
  errorcode_30010: '此箱中此产品已完成绑定请求次数。',
  errorcode_30011: '此EPC无法解析出UPC，请扫描QR Code完成绑定。',
  errorcode_30013: `此<span class='textDecoration'>EPC</span>已被
    <span class='link_name_dashboard_error'>当前箱号</span>绑定，
    请扫描<span class='textDecoration'>QR Code</span>完成绑定。`,
  errorcode_30012: `此<span class='textDecoration'>EPC</span>已被
    <span class='link_name_dashboard_error'>其他箱号</span>绑定，
    请扫描<span class='textDecoration'>QR Code</span>完成绑定。`,
  errorcode_30018: `此<span class='textDecoration'>QR Code</span>已被
    <span class='link_name_dashboard_error'>当前箱号</span>绑定，
    请扫描<span class='textDecoration'>EPC</span>完成绑定。`,
  errorcode_30017: `此<span class='textDecoration'>QR Code</span>已被
    <span class='link_name_dashboard_error'>其他箱号</span>绑定，
    请扫描<span class='textDecoration'>EPC</span>完成绑定。`,
  errorcode_30014: 'EPC对应UPC与实际扫描UPC不符。',
  errorcode_30015: '无效产品主数据。',
  errorcode_30016: '未配置设备编号，请联系RFID Admin Team进行配置。',
  errorcode_7006: '未收集到任何EPC信息，请重试扫描。',
  errorcode_9: '离周围商品太近(<10cm)，请调整后复扫。',
  errorcode_10: '此箱绑定未完成，请再次确认是否扫描下一箱。未绑定SKU为: ',
  errorcode_11: '当前产品绑定未完成，请再次确认是否开始绑定下一件。',
  cartonNoEmpty: '箱号不能为空，请扫描或输入箱号。',
  errorcode_30001: '箱号不能为空。',
  errorcode_30002: '该箱号不存在在T-Hub系统中，无法解绑。',
  errorcode_30003: '该箱号暂未绑定，无需解绑。',
  errorcode_30004: 'EPC和QR Code中至少有一个不能为空。',
  errorcode_30005: '该产品不存在在T-Hub系统中，无法解绑。',
  errorcode_30006: '该产品暂未绑定，无需解绑。',
  readEpcErr: '无法识别中间件。请在桌面应用程序“RfidDemo”中启动中间件',
  multipleEpc: '离周围商品太近(<10cm)，请调整后复扫。',
  'bound-1': '未绑定',
  bound0: '未绑定',
  bound1: '已绑定',
  bound2: '已解绑',
  boundCarton0: '未绑定',
  boundCarton1: '绑定中',
  boundCarton2: '完全绑定',
  boundCarton3: '解绑',
  boundCarton4: '强制绑定',
  statusSignal: '箱状态',
  itemSstatus: '件状态',
  productCode: '产品代码',
  backFirstPage: '返回',
  back: '返回',
  rfIbScanningTitle1025: '1025 RFID箱扫描 – 入库',
  rfObScanningTitle1025: '1025 RFID箱扫描 – 出库',
  rfIbScanningTitle1027: '1027 RFID箱扫描 – 入库',
  rfObScanningTitle1027: '1027 RFID箱扫描 – 出库',
  menu: '主菜单',
  openCarton: '开箱检查',
  reScan: '重扫',
  scanEpcs: '环箱扫描 ',
  asnQty: 'ASN件数',
  giQty: 'GI件数',
  systemQty: '系统判断件数',
  latestScanResult: '系统最新扫描结果：',
  latestValidationScanResult: '系统最新对比结果：',
  scanResult: '本次箱扫描结果：',
  validationResult: '本次对比结果：',
  scanDataResult: '扫描结果：',
  comfirmScanResult: '开箱查验后确认箱结果为：',
  productShortage: '实物少件',
  productOverage: '实物多件',
  specialProduct: '特殊产品',
  manualUnitScan: '转入人工逐件扫描',
  accurate: '准确',
  Unexpected: '未知箱号 ',
  epcShortage: 'EPC少件',
  upcMismatched: 'UPC 混件',
  epcOverage: 'EPC多件',
  manualConfirm: '人工确认',
  newCarton: '新箱',
  productShortageMsg: '请再次确认已人工查验该箱产品结果符合<strong>“实物少件”</strong>，提交后系统将自动进入下一箱。',
  productOverageMsg: '请再次确认已人工查验该箱产品结果符合<strong>”实物多件“</strong>，提交后系统将自动进入下一箱。',
  specialProductMsg: '请再次确认已人工查验该箱产品结果符合<strong>”特殊产品“</strong>，提交后系统将自动进入下一箱。',
  scanWarnMsg: '请扣动并长按扳机开始扫描, 松开扳机结束扫描',
  relabel: '补标请点击',
  submit: '提交',
  backPage: '返回',
  manualAccurate: '正确',
  epcUpdate: '系统已更新',
  unitCount: '该箱扫描计数',
  manualScanTip:
    '请先确认产品SKU正确，且周围无其他产品干扰后，扫描产品QR Code和UPC条形码。QR Code无法扫描时可只扫描产品UPC条形码。',
  confirm: '确认',
  cancel: '取消',
  invalidUpc: '无效UPC格式，请重试。正确UPC格式应为：00197863493015。',
  invalidQrCode: '无效 QR Code，请重试。正确QR Code格式应为： HTTPS://QR.NIKE.COM/04B5Z1S0ERWR1。',
  upcUnmatched: 'QR Code对应UPC与实际扫描UPC不符。',
  physicalSkuCorrect: '实物SKU正确',
  physicalSkuInCorrect: '实物SKU错误',
  manualInCorrectTip: '请再次确认已人工查验该产品结果符合<strong>”实物SKU错误“</strong>，提交后系统将自动进入下一箱。',
  noRfidTag: '产品无RFID标签 ',
  scanNoResponse: 'RFID扫描无反应 ',
  physicalSkuCorrectTip: '识别到不属于该箱的SKU，请查看产品包装并查验产品SKU是否正确。',
  errorcode_7007: '该EPC已被产品绑定，请移除RFID标签，并按UPC进行补标。',
  confirmSubmitNextCarton: '请再次确认，提交后系统将自动进入下一箱。',
  manualScanResultInvalidTipFon: '此箱当前复检结果与ASN仍有差异，请再次确认是否已扫完全部产品，并提交该箱信息？',
  invalidScanResultTip: '差异结果为：',
  manualScanResultInvalidTipBac: '件',
  exceeds: '（多件件数）',
  missing: '（少件件数）',
  cartonCommitSuccess: '提交成功，系统将自动进入下一箱。',
  noRoundScanData: '未收集到任何EPC信息，请重试扫描。',
  labelTips: '请选择一个补标原因：',
  noExistInCarton: '该箱号中无此产品，请再次确认。',
  errorcode_9000: '仅支持以下二维码。',
  errorcode_9001: '仅支持以下二维码。',
  errorcode_9002: '仅支持以下二维码。',
  errorcode_604: '该箱号已被取消。'
}
